'use client';

import { ClubAdminAction } from '../club-ki-assistant/types';

export type AppSupportKnowledgeRoute = {
    route: string;
    routeTitle?: string;
};

export type AppSupportKnowledgeItem = {
    modul?: string;
    title?: string;
    contents?: string;
    routen?: AppSupportKnowledgeRoute[];
};

export type AppSupportKnowledgeView = {
    type: 'knowledge';
    items?: AppSupportKnowledgeItem[];
};

export const APP_SUPPORT_DATA_VIEW_TYPES = [
    'members',
    'bookings',
    'allocations',
    'spaces',
    'space_groups',
    'events',
    'invoices',
    'statistics',
    'inquiries',
    'course_popularity'
] as const;

export type AppSupportDataViewType = (typeof APP_SUPPORT_DATA_VIEW_TYPES)[number];

export type AppSupportDataView = {
    type: AppSupportDataViewType;
    items?: Record<string, unknown>[];
};

export type AppSupportView = AppSupportKnowledgeView | AppSupportDataView;

export type AppSupportFeedback = 'up' | 'down' | null;

export type AppSupportActionStatus = 'pending' | 'approved' | 'rejected';

export type AppSupportMessage = {
    id: string;
    role: 'user' | 'model';
    text: string;
    routeTitle?: string | null;
    suggestedRoute?: string | null;
    view?: AppSupportView | null;
    views?: AppSupportView[] | null;
    actions?: ClubAdminAction[] | null;
    /** Keyed by action_id; unset means the action is still pending. */
    actionStatus?: Record<number, AppSupportActionStatus>;
    feedback?: AppSupportFeedback;
    usageId?: number | null;
};

export type AppSupportHistoryItem = {
    userQuestion: string;
    AIResponse: string;
};

export type AppSupportChatResponse = {
    answer?: string;
    message?: string;
    error?: string;
    route_title?: string | null;
    suggested_route?: string | null;
    view?: AppSupportView | null;
    views?: AppSupportView[] | null;
    actions?: ClubAdminAction[] | null;
    admin_mode?: boolean;
    usage_id?: number | null;
};
